/* Pultec modern — interactions.
   Vanilla, no dependencies. Everything here is progressive enhancement:
   the page reads correctly with JS off, and prefers-reduced-motion
   disables every animation outright. */

(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- scroll reveal — one slow, weighted entrance ---- */
  if (!reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.mod-reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.mod-reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---- The Curve ------------------------------------------------------

     Not a filter model. Every number below was read off Pulse Techniques'
     own Audio Precision sweeps of an EQP-1A3 and is interpolated between,
     never extrapolated past the ends.

     LOW END  — four settings, boost and attenuator advanced together at
     100 CPS. The slider moves between them.

     HIGH END — one setting: the 5 KCS peak boost, the high shelf
     attenuator, and the two engaged together. Note these do NOT sum
     arithmetically. Boost alone peaks at +19.5 and the attenuator alone is
     -17.6 at 5 KCS, yet together they measure +14.3, because both controls
     work on the same passive network. That is the whole point of the
     interaction, so the measured trace is shown rather than a sum.

     Minus signs are literal characters, not escapes: this file is written
     through a pipeline that passes backslashes through unprocessed. */
  document.querySelectorAll('[data-curve]').forEach(function (root) {
    var svg = root.querySelector('[data-curve-svg]');
    var sum = root.querySelector('[data-curve-sum]');
    if (!svg || !sum) return;

    var gGrid = root.querySelector('[data-curve-gridlines]');
    var gY = root.querySelector('[data-curve-yticks]');
    var gX = root.querySelector('[data-curve-xticks]');
    var zero = root.querySelector('[data-curve-zero]');
    var axis = root.querySelector('[data-curve-axis]');
    var refs = root.querySelectorAll('[data-curve-ref]');
    var key = root.querySelector('[data-curve-key]');
    var readout = root.querySelector('[data-curve-readout]');
    var amount = root.querySelector('[data-curve-amount]');
    var amountOut = root.querySelector('[data-curve-amount-out]');
    var attenBtn = root.querySelector('[data-curve-atten]');
    var copyLf = root.querySelector('[data-curve-copy-lf]');
    var copyHf = root.querySelector('[data-curve-copy-hf]');

    var NS = 'http://www.w3.org/2000/svg';
    var X0 = 56, X1 = 700, Y0 = 20, Y1 = 320;

    var LF_F = [10,20,30,50,70,100,150,200,300,400,500,700,1000,1500,2000,3000,5000,10000,20000];
    var LF = [
      { boost: 0,    db: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0] },
      { boost: 0.9,  db: [0.6,0.9,0.9,0.9,0.9,0.9,0.9,0.8,0.7,0.5,0.3,-0.3,-1.0,-1.5,-1.6,-1.2,-0.8,-0.6,-0.5] },
      { boost: 4.3,  db: [3.9,4.2,4.3,4.3,4.3,4.2,4.0,3.7,2.9,2.0,1.2,-0.6,-2.4,-2.8,-2.4,-1.4,-0.8,-0.6,-0.5] },
      { boost: 10.2, db: [9.7,10.2,10.2,9.8,9.2,8.4,7.0,5.8,3.6,1.9,0.6,-2.2,-5.2,-5.4,-3.9,-1.6,-0.8,-0.6,-0.5] },
      { boost: 15.2, db: [14.8,15.2,15.2,14.6,13.6,12.3,10.2,8.3,4.8,2.2,0.0,-3.8,-7.3,-6.8,-4.6,-1.8,-0.8,-0.6,-0.5] }
    ];

    var HF_F     = [100,200,300,500,700,1000,1500,2000,3000,4000,4500,5000,5500,6000,7000,8000,10000,15000,20000,30000,50000];
    var HF_BOOST = [-0.2,-0.1,0.0,0.3,0.6,1.0,2.0,3.3,7.0,12.5,16.0,19.5,16.5,14.0,10.5,8.5,5.8,3.2,2.0,0.5,-2.0];
    var HF_ATTEN = [-0.3,-0.7,-1.2,-2.6,-4.0,-6.0,-8.8,-11.2,-14.5,-16.3,-17.0,-17.6,-18.0,-18.4,-19.0,-19.4,-20.0,-20.6,-20.9,-21.4,-22.6];
    var HF_BOTH  = [-0.4,-0.9,-1.5,-3.1,-4.3,-4.9,-4.9,-4.7,-3.0,2.0,7.0,14.3,7.5,3.0,-3.5,-7.5,-12.0,-16.5,-18.5,-20.2,-21.5];

    var MODES = {
      lf: {
        fMin: 10, fMax: 20000, dbTop: 18, dbSpan: 28,
        xt: [[10,'10'],[20,'20'],[50,'50'],[100,'100'],[200,'200'],[500,'500'],[1000,'1k'],[2000,'2k'],[5000,'5k'],[10000,'10k'],[20000,'20k']],
        yt: [15,10,5,0,-5,-10]
      },
      hf: {
        fMin: 100, fMax: 50000, dbTop: 22, dbSpan: 48,
        xt: [[100,'100'],[200,'200'],[500,'500'],[1000,'1k'],[2000,'2k'],[5000,'5k'],[10000,'10k'],[20000,'20k'],[50000,'50k']],
        yt: [20,10,0,-10,-20]
      }
    };

    var mode = 'lf';
    var attenIn = true;

    function clear(el) { while (el && el.firstChild) el.removeChild(el.firstChild); }
    function mk(tag, attrs) {
      var e = document.createElementNS(NS, tag);
      for (var k in attrs) { if (attrs.hasOwnProperty(k)) e.setAttribute(k, attrs[k]); }
      return e;
    }
    function fx(m, f) {
      var l0 = Math.log(m.fMin) / Math.LN10;
      var ls = (Math.log(m.fMax) / Math.LN10) - l0;
      return X0 + ((Math.log(f) / Math.LN10) - l0) / ls * (X1 - X0);
    }
    function fy(m, db) { return Y0 + (m.dbTop - db) / m.dbSpan * (Y1 - Y0); }

    function grid(m) {
      clear(gGrid); clear(gY); clear(gX);
      m.xt.forEach(function (t) {
        var x = fx(m, t[0]).toFixed(1);
        gGrid.appendChild(mk('line', { x1: x, y1: Y0, x2: x, y2: Y1 }));
        var tx = mk('text', { x: x, y: 338 });
        tx.textContent = t[1];
        gX.appendChild(tx);
      });
      m.yt.forEach(function (db) {
        var y = fy(m, db);
        if (db !== 0) gGrid.appendChild(mk('line', { x1: X0, y1: y.toFixed(1), x2: X1, y2: y.toFixed(1) }));
        var tx = mk('text', { x: 48, y: (y + 4).toFixed(1) });
        tx.textContent = (db > 0 ? '+' : (db < 0 ? '−' : '')) + Math.abs(db);
        gY.appendChild(tx);
      });
      var z = fy(m, 0).toFixed(1);
      zero.setAttribute('y1', z);
      zero.setAttribute('y2', z);
      if (axis) axis.textContent = 'CPS';
    }

    /* Catmull-Rom through the measured points, converted to cubic Beziers.
       A plain polyline kinks visibly at every reading. */
    function path(m, F, db) {
      var p = [];
      for (var i = 0; i < F.length; i++) p.push([fx(m, F[i]), fy(m, db[i])]);
      var d = 'M' + p[0][0].toFixed(1) + ' ' + p[0][1].toFixed(1);
      for (var j = 0; j < p.length - 1; j++) {
        var p0 = p[j > 0 ? j - 1 : 0], p1 = p[j], p2 = p[j + 1];
        var p3 = p[j + 2 < p.length ? j + 2 : j + 1];
        d += ' C' + (p1[0] + (p2[0] - p0[0]) / 6).toFixed(1) + ' ' + (p1[1] + (p2[1] - p0[1]) / 6).toFixed(1) +
             ',' + (p2[0] - (p3[0] - p1[0]) / 6).toFixed(1) + ' ' + (p2[1] - (p3[1] - p1[1]) / 6).toFixed(1) +
             ',' + p2[0].toFixed(1) + ' ' + p2[1].toFixed(1);
      }
      return d;
    }

    function lfAt(g) {
      if (g <= LF[0].boost) return LF[0].db.slice();
      for (var i = 1; i < LF.length; i++) {
        if (g <= LF[i].boost) {
          var a = LF[i - 1], b = LF[i];
          var k = (g - a.boost) / (b.boost - a.boost);
          return a.db.map(function (v, j) { return v + (b.db[j] - v) * k; });
        }
      }
      return LF[LF.length - 1].db.slice();
    }

    function hz(f) { return f >= 1000 ? (f / 1000) + ' KCS' : f + ' CPS'; }
    function sgn(v) { return (v >= 0 ? '+' : '−') + Math.abs(v).toFixed(1); }
    function peak(F, db) {
      var v = -Infinity, i = 0;
      for (var k = 0; k < db.length; k++) { if (db[k] > v) { v = db[k]; i = k; } }
      return { db: v, f: F[i] };
    }
    function trough(F, db) {
      var v = Infinity, i = 0;
      for (var k = 0; k < db.length; k++) { if (db[k] < v) { v = db[k]; i = k; } }
      return { db: v, f: F[i] };
    }

    function setRef(i, m, F, db, dashed) {
      var el = refs[i];
      if (!el) return;
      el.setAttribute('d', db ? path(m, F, db) : '');
      el.classList.toggle('is-dashed', !!dashed);
    }

    function render() {
      var m = MODES[mode];
      grid(m);

      if (mode === 'lf') {
        var g = amount ? parseFloat(amount.value) : 10;
        var db = lfAt(g);
        sum.setAttribute('d', path(m, LF_F, db));
        if (amountOut) amountOut.textContent = g.toFixed(1);
        setRef(0, m, LF_F, LF[2].db, false);
        setRef(1, m, LF_F, LF[3].db, false);
        setRef(2, m, LF_F, LF[4].db, false);
        if (key) key.innerHTML =
          '<span><i class="amber"></i>What the mix hears</span>' +
          '<span><i class="ghost"></i>The other settings on the dial</span>';
        if (readout) {
          var t = trough(LF_F, db);
          readout.textContent = 'Shelf ' + sgn(db[2]) + ' dB at 30 CPS · dip ' + sgn(t.db) + ' dB at ' + hz(t.f);
        }
      } else {
        var active = attenIn ? HF_BOTH : HF_BOOST;
        sum.setAttribute('d', path(m, HF_F, active));
        setRef(0, m, HF_F, attenIn ? HF_BOOST : null, false);
        setRef(1, m, HF_F, HF_ATTEN, true);
        setRef(2, m, HF_F, null, false);
        if (key) key.innerHTML = attenIn
          ? '<span><i class="amber"></i>Both engaged</span>' +
            '<span><i class="ghost"></i>Boost alone</span>' +
            '<span><i class="ghost-dash"></i>Attenuator alone</span>'
          : '<span><i class="amber"></i>Boost alone</span>' +
            '<span><i class="ghost-dash"></i>Attenuator alone</span>';
        if (readout) {
          var pk = peak(HF_F, active);
          if (attenIn) {
            var tr = trough(HF_F.slice(0, 9), active.slice(0, 9));
            readout.textContent = 'Peak ' + sgn(pk.db) + ' dB at ' + hz(pk.f) + ' · dip ' + sgn(tr.db) + ' dB at ' + hz(tr.f);
          } else {
            readout.textContent = 'Peak ' + sgn(pk.db) + ' dB at ' + hz(pk.f) + ' · broad, no attenuator';
          }
        }
      }
    }

    root.querySelectorAll('[data-curve-mode]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        mode = btn.getAttribute('data-curve-mode');
        root.querySelectorAll('[data-curve-mode]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        root.querySelectorAll('[data-curve-ctl]').forEach(function (c) {
          c.hidden = c.getAttribute('data-curve-ctl') !== mode;
        });
        if (copyLf) copyLf.hidden = mode !== 'lf';
        if (copyHf) copyHf.hidden = mode !== 'hf';
        render();
      });
    });

    if (attenBtn) {
      attenBtn.addEventListener('click', function () {
        attenIn = !attenIn;
        attenBtn.setAttribute('aria-pressed', attenIn ? 'true' : 'false');
        attenBtn.textContent = attenIn ? 'Attenuator in' : 'Attenuator out';
        render();
      });
    }

    if (amount) amount.addEventListener('input', render);
    render();

    if (!reduce && 'IntersectionObserver' in window) {
      var len = 1800;
      sum.style.strokeDasharray = len;
      sum.style.strokeDashoffset = len;
      new IntersectionObserver(function (es, obs) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          sum.style.transition = 'stroke-dashoffset 1.6s cubic-bezier(.3,.5,.2,1)';
          sum.style.strokeDashoffset = '0';
          obs.disconnect();
        });
      }, { threshold: 0.4 }).observe(root);
    }
  });

  /* ---- Proof strip: a stop control that does not depend on hover ---- */
  document.querySelectorAll('[data-proof]').forEach(function (root) {
    var btn = root.querySelector('[data-proof-pause]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var paused = root.classList.toggle('is-paused');
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.textContent = paused ? 'Play' : 'Pause';
    });
  });

  /* ---- Timeline: say that the rail continues ---- */
  document.querySelectorAll('[data-timeline]').forEach(function (wrap) {
    var track = wrap.querySelector('.mod-timeline');
    if (!track) return;
    var ticking = false;

    function state() {
      var max = track.scrollWidth - track.clientWidth;
      var atEnd = max <= 1 || track.scrollLeft >= max - 2;
      track.classList.toggle('is-end', atEnd);
      track.classList.toggle('is-mid', track.scrollLeft > 2);
      wrap.classList.toggle('is-end', atEnd);
      ticking = false;
    }
    function queue() { if (!ticking) { ticking = true; requestAnimationFrame(state); } }
    track.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    state();
  });

  /* ---- A/B player ---- */
  document.querySelectorAll('[data-ab]').forEach(function (root) {
    var a = root.querySelector('audio[data-ab-a]');
    var b = root.querySelector('audio[data-ab-b]');
    var play = root.querySelector('[data-ab-play]');
    var swap = root.querySelector('[data-ab-swap]');
    if (!a || !b || !play || !swap) return;
    var current = a, playing = false;

    function syncTo(next) {
      next.currentTime = current.currentTime;
      if (playing) { current.pause(); next.play(); }
      current = next;
      swap.setAttribute('aria-pressed', current === b ? 'true' : 'false');
      swap.textContent = current === b ? 'Pultec in' : 'Bypass';
    }
    play.addEventListener('click', function () {
      playing = !playing;
      playing ? current.play() : current.pause();
      play.textContent = playing ? 'Pause' : 'Play';
      play.setAttribute('aria-pressed', playing ? 'true' : 'false');
    });
    swap.addEventListener('click', function () { syncTo(current === a ? b : a); });
    [a, b].forEach(function (el) { el.addEventListener('ended', function () {
      playing = false; play.textContent = 'Play'; play.setAttribute('aria-pressed', 'false');
    }); });
  });

  /* ---- PDP: keep price and availability in step with the variant ---- */
  document.querySelectorAll('[data-mod-buy]').forEach(function (root) {
    var sel = root.querySelector('select[name="id"]');
    if (!sel) return;
    var priceEl = root.querySelector('[data-mod-price]');
    var addBtn = root.querySelector('[data-mod-add]');

    function sync() {
      var opt = sel.options[sel.selectedIndex];
      if (!opt) return;
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      if (addBtn) {
        var ok = opt.dataset.available === 'true';
        addBtn.disabled = !ok;
        addBtn.textContent = ok ? 'Add to cart' : 'Unavailable';
      }
    }
    sel.addEventListener('change', sync);
    sync();
  });

  /* ---- collection filters: bat-handle toggles over data attributes ---- */
  document.querySelectorAll('[data-filterbar]').forEach(function (bar) {
    var scope = document.querySelector(bar.getAttribute('data-filterbar')) || document;
    var cards = scope.querySelectorAll('[data-amp]');
    var state = { amp: null, format: null };
    function apply() {
      cards.forEach(function (c) {
        var okAmp = !state.amp || c.getAttribute('data-amp') === state.amp;
        var okFmt = !state.format || (c.getAttribute('data-format') || '').indexOf(state.format) !== -1;
        c.hidden = !(okAmp && okFmt);
      });
    }
    bar.querySelectorAll('.mod-toggle').forEach(function (t) {
      t.addEventListener('click', function () {
        var group = t.getAttribute('data-group');
        var val = t.getAttribute('data-value');
        var on = t.getAttribute('aria-pressed') === 'true';
        bar.querySelectorAll('.mod-toggle[data-group="' + group + '"]').forEach(function (x) {
          x.setAttribute('aria-pressed', 'false');
        });
        state[group] = on ? null : val;
        if (!on) t.setAttribute('aria-pressed', 'true');
        apply();
      });
    });
  });
})();